$(document).ready( function(){
	if ($('#g-map').length > 0) {
		mapInit();
	}
});

var map;

// Grab the location data and use as inital loaction
var latLng = {
		lat: parseFloat($('.location-data').attr('data-lat')),
		lng: parseFloat($('.location-data').attr('data-lng'))
};

function mapInit() {

    // Map Options
	var mapOptions = {
		zoom: 17,
        center: latLng,
		scrollwheel: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		navigationControl: false,
		draggable: true,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false
	}
	
    // Create Map Object
    var mapCanvas = document.getElementById('g-map');
	map = new google.maps.Map(mapCanvas, mapOptions);

	// Create Marker
    var marker = new google.maps.Marker({
        position: latLng,
        map: map
    });
}